export default __webpack_public_path__ + "static/media/img333.a024a6a8.png";